module.exports = __webpack_public_path__ + "static/img/Featured-Freebie-Profile-Image.4dfd62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/Featured-Freebie-Profile-Image.png
// module id = Fmx9
// module chunks = 44